


































import {Component, Vue} from "vue-property-decorator";
import {EmployeeStore} from "@/modules/employees/store";
import CommonStatusLabel from "@/shared/components/CommonStatusLabel/index.vue";
import EmployeeTableAction from "@/modules/employees/List/components/TableAction.vue";
import EmployeeSearch from "@/modules/employees/List/components/Search.vue";
import EmployeeTypeLabel from "@/modules/employees/List/components/EmployeeTypeLabel.vue";
import {PAGE_SIZE_OPTIONS} from "@/shared/constant";
import {EmployeeParams} from "@/modules/employees/params";
import {mixins} from "vue-class-component";
import {CommonMixin} from "@/shared/services/mixin";

@Component({
    name: "EmployeeList",
    components: {EmployeeTypeLabel, EmployeeTableAction, EmployeeSearch, CommonStatusLabel}
})
export default class extends mixins(CommonMixin) {
    columns = [
        {
            title: "Thao tác",
            dataIndex: "rowGuid",
            key: "rowGuid",
            scopedSlots: {customRender: 'action'},
            align: 'center',
            width: 100
        },
        {
            title: "Mã nhân viên",
            dataIndex: "employeeCode",
            key: "employeeCode",
            width: 120,
            ellipsis: true
        },
        {
            title: "Tài khoản",
            dataIndex: "account.username",
            key: "username",
            width: 120,
            ellipsis: true
        },
        {
            title: "Họ tên",
            dataIndex: "fullname",
            key: "fullname",
            width: 150,
            ellipsis: true
        },
        {
            title: "Số điện thoại",
            dataIndex: "phoneNumber",
            key: "phoneNumber",
            width: 150,
            ellipsis: true
        },
        {
            title: "Chức vụ",
            dataIndex: "type",
            key: "type",
            scopedSlots: {customRender: "type"},
            width: 200,
            ellipsis: true
        },
        {
            title: "Trạng thái",
            dataIndex: "status",
            key: "status",
            scopedSlots: {customRender: 'status'},
            width: 100,
            ellipsis: true
        }
    ];

    created() {
        if (this.isAdmin) {
            this.columns = [
                ...this.columns,
                {
                    title: "Bưu cục",
                    dataIndex: "postOffice.name",
                    key: "postOfficeRowGuid",
                    width: 180
                } as any
            ];
        }
        EmployeeStore.updateEmployeeParams(new EmployeeParams());
        EmployeeStore.listEmployee({params: EmployeeStore.params, refresh: true});
    }

    get employees() {
        return EmployeeStore.ids.map((id: string) => EmployeeStore.data[id]);
    }

    get pagination() {
        return {
            current: EmployeeStore.meta.page,
            pageSize: EmployeeStore.meta.limit,
            total: EmployeeStore.meta.total,
            showTotal: (total: number) => `Tổng cộng ${total} nhân viên`,
            showQuickJumper: true,
            showSizeChanger: true,
            pageSizeOptions: PAGE_SIZE_OPTIONS
        }
    }

    onChangePage(pagination: any) {
        const params = {...EmployeeStore.params, page: pagination.current, limit: pagination.pageSize};
        EmployeeStore.updateEmployeeParams(params);
        EmployeeStore.listEmployee({params, refresh: true});
    }
}
